import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomService {

  constructor() { }

  DatetoLocal(thisdate:any){
    const date1 = new Date(thisdate);
    let options:any = {
      // weekday: "short",
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };

    return date1.toLocaleString('th-TH', options);
  }

  Date2en(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }  

  getThaiDateToday(date: string): string {
    const today = new Date(date);
    const thaiDate = today.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });
    return thaiDate;
  }  

}
